<template>
  <div class="grid grid-cols-2 md:grid-cols-1 gap-4 auto-rows-max">
    <div v-for="preset in recurrencePresets" :key="preset.label">
      <Button
        :class="[
          'recurrence-button w-full text-xs',
          {
            'bg-gray-100 *:!text-gray-900 border-gray-100 *:hover:!text-white':
              !isSelected(preset)
          }
        ]"
        :data-cy="`recurrence-${preset.name}`"
        @click="setSelectedRecurrenceOption(preset.name)"
      >
        <template #label>
          <div
            class="flex flex-col md:flex-row md:gap-1 w-full md:items-start justify-start"
          >
            <span class="font-semibold">{{ preset.label }}</span>
            <span class="subtitle">{{ preset.subtitle(startDate) }}</span>
          </div>
        </template>
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Moment } from "moment";

import Button from "@/components/Button.vue";
import {
  RecurrencePreset,
  recurrencePresets
} from "@/typings/calendarEventForm";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: String,
    required: true
  },
  startDate: {
    type: Object as () => Moment,
    required: true
  }
});

function setSelectedRecurrenceOption(clickedPreset: string) {
  emit("update:modelValue", clickedPreset);
}

function isSelected(preset: RecurrencePreset): boolean {
  return preset.name === props.modelValue;
}
</script>

<style lang="scss">
.recurrence-button > div {
  width: 100%;
}
</style>
